import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthApi} from './api/AuthApi';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {GeneralServicesImplService} from './general-services-impl.service';
import * as servers from './api/servers';
import {getHeaders, getLoginHeaders, urls} from './api/urls';
import { ProjectConstants } from '../app/project-constants';

@Injectable()
export class LoginService extends ProjectConstants {

  baseUrl: string = servers.apiUrl;
  http: HttpClient;

  constructor(private authApi: AuthApi, http: HttpClient) {
    super();
    this.http = http;
  }

  getAccessToken(username: string, password: string): Observable<any> {
    let model = new HttpParams();
    const oAuthUrl = servers.authUrl;

    model = model.append('username', username);
    model = model.append('password', password);
    model = model.append('grant_type', 'password');
    model = model.append('client_id', 'my-client');

    const bodyRequest = model.toString();

    const loginHeaders = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + btoa('my-client:my-secret')
    };

    return this.http.post<any>(oAuthUrl, bodyRequest,
      {headers: loginHeaders})
      .pipe(
        map(resp => {
          if (resp && resp.access_token) {
            sessionStorage.setItem('authToken', resp.access_token);
            sessionStorage.setItem('refreshToken', resp.refresh_token);
            sessionStorage.setItem('expires', resp.expires_in);
          }
        })
      );
  }

  getUserByUsername(offset: any, filter?: any): Observable<any> {
    const url = this.baseUrl + urls.users + this.LINKS.GET_USER_BY_USERNAME;
    const body =  filter ? JSON.stringify(filter) : null;
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    };
    return this.http.post( url, body, {headers: headers, responseType: 'json', params: offset})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

}
